import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

type RecommendedToolCard = Readonly<{
  title: string;
  description?: string;
  keywords?: readonly string[];
}>;

/**
 * Register the tools actually on screen with Lubav, so it discusses these rather than guessing at
 * the catalog. Registers nothing when none resolved to a live tool.
 */
export const useRecommendedToolsAgentContext = (cards: readonly RecommendedToolCard[]) => {
  useRegisterAgentContext(
    cards.length
      ? {
          kind: 'list',
          description: 'Tools in the "Recommended Tools & Resources" section',
          data: cards.map((card) => ({
            title: card.title,
            description: card.description,
            keywords: card.keywords,
          })),
        }
      : null,
  );
};
